import {Stack, styled} from '@mui/material';
import Icon from 'presentation/icons';

const StyledContainer = styled(Stack)`
	flex-direction: row;
	padding: 16px;
	align-items: center;
	gap: 8px;
	border-radius: 8px;
	background: ${({theme}) => theme.colors.light.primary['07Percent']};
`;

const StyledContainerIcon = styled(Stack)`
	width: 40px;
	height: 40px;
	min-width: 40px;
	min-height: 40px;
	justify-content: center;
	align-items: center;
	gap: 16px;
	border-radius: 100px;
	background: ${({theme}) => theme.colors.light.primary['12Percent']};
`;

const StyledIcon = styled(Icon)`
	color: ${({theme}) => theme.colors.light.primary.main};
`;

export {StyledContainer, StyledContainerIcon, StyledIcon};
